import { useEffect, useRef } from 'react';
import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';

import Input from '../Input';
import { Wrapper } from './style';

type CounterProps = {
  value: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange: (val: number) => void;
};

const Counter: React.FC<CounterProps> = props => {
  const { value, min, max, disabled, onChange } = props;

  const inputRef = useRef<HTMLInputElement | null>();

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.value = String(value);
    }
  }, [value]);

  const changeValue = (val: number): number => {
    const floorVal = Math.floor(val);
    if (min !== undefined && floorVal <= min) {
      return min;
    }
    if (max !== undefined && floorVal >= max) {
      return max;
    }
    return floorVal;
  };

  const setValue = (_value: number | string) => {
    if (inputRef && inputRef.current) {
      inputRef.current.value = String(_value);
      onChange(Number(_value));
    }
  };

  const handleClick = (_value: number) => {
    setValue(_value);
    onChange(_value);
  };

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const val = e.target.value ? Number(e.target.value) : 1;
    setValue(changeValue(val));
  };

  return (
    <Wrapper>
      <Button
        size="m"
        bgColor="primary"
        fontWeight="bold"
        outline
        radius="s"
        disabled={disabled || (min !== undefined && value <= min)}
        onClick={() => handleClick(value - 1)}
        data-testid="sub"
      >
        ー
      </Button>
      <Input
        ref={inputRef}
        type="number"
        defaultValue={value}
        disabled={disabled}
        pattern="\d*"
        onBlur={(e: React.ChangeEvent<HTMLInputElement>) => handleBlur(e)}
      />
      <Button
        size="m"
        bgColor="primary"
        fontWeight="bold"
        radius="s"
        disabled={disabled || (max !== undefined && max <= value)}
        onClick={() => handleClick(value + 1)}
        data-testid="add"
      >
        ＋
      </Button>
    </Wrapper>
  );
};

export default Counter;
